module.exports = __webpack_public_path__ + "img/icon_lichen.b0ce5bb4.png";